import { StatusBadge } from './StatusBadge';

export function AdminPaymentsTab({ stats, transactions }) {
  const grossRevenue = stats?.total_gross_revenue ?? stats?.total_revenue ?? 0;
  const netRevenue = stats?.total_revenue ?? 0;
  const totalRefunds = stats?.total_refunds ?? 0;
  const grossCommission = stats?.total_gross_commission ?? stats?.total_commission ?? 0;
  const netCommission = stats?.total_commission ?? 0;
  const commissionRefunded = Math.max(0, grossCommission - netCommission);

  return (
    <>
      <div className="grid md:grid-cols-3 gap-4 mb-4" data-testid="admin-revenue-breakdown">
        <div className="card-surface p-5">
          <p className="text-sm text-stone-500 mb-1">Gross Revenue</p>
          <p className="text-2xl font-semibold text-[#1A1A1A]" data-testid="gross-revenue">£{grossRevenue.toFixed(2)}</p>
          <p className="text-xs text-stone-400 mt-1">Before refunds</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-sm text-stone-500 mb-1">Refunds Issued</p>
          <p className="text-2xl font-semibold text-red-500" data-testid="total-refunds">-£{totalRefunds.toFixed(2)}</p>
          <p className="text-xs text-stone-400 mt-1">Returned to clients</p>
        </div>
        <div className="card-surface p-5 ring-1 ring-[#D4AF37]/30">
          <p className="text-sm text-stone-500 mb-1">Net Revenue</p>
          <p className="text-2xl font-semibold text-green-600" data-testid="net-revenue">£{netRevenue.toFixed(2)}</p>
          <p className="text-xs text-stone-400 mt-1">After refunds, retained</p>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        <div className="card-surface p-5">
          <p className="text-sm text-stone-500 mb-1">Platform Commission (Net)</p>
          <p className="text-2xl font-semibold text-[#D4AF37]" data-testid="net-commission">£{netCommission.toFixed(2)}</p>
          {commissionRefunded > 0 && (
            <p className="text-xs text-stone-400 mt-1">Gross £{grossCommission.toFixed(2)}, -£{commissionRefunded.toFixed(2)} refunded</p>
          )}
        </div>
        <div className="card-surface p-5">
          <p className="text-sm text-stone-500 mb-1">Provider Payouts (Net)</p>
          <p className="text-2xl font-semibold text-green-600">£{(netRevenue - netCommission).toFixed(2)}</p>
          <p className="text-xs text-stone-400 mt-1">After refund adjustments</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-sm text-stone-500 mb-1">Refund Rate</p>
          <p className="text-2xl font-semibold text-stone-600">
            {grossRevenue > 0 ? ((totalRefunds / grossRevenue) * 100).toFixed(1) : '0.0'}%
          </p>
          <p className="text-xs text-stone-400 mt-1">of gross revenue</p>
        </div>
      </div>
      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#F9F6F0]">
              <tr>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Date</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Booking</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Amount</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Commission</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Provider Payout</th>
                <th className="text-left py-3 px-4 text-stone-600 font-medium text-sm">Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr><td colSpan={6} className="py-12 text-center text-stone-400">No transactions yet</td></tr>
              ) : transactions.map((t) => (
                <tr key={t.booking_id || t.created_at} className="border-b border-[#E6E4DD] hover:bg-[#F9F6F0]">
                  <td className="py-3 px-4 text-sm text-stone-500">{t.created_at ? new Date(t.created_at).toLocaleDateString('en-GB') : ','}</td>
                  <td className="py-3 px-4 text-sm text-stone-600">{t.booking_id?.slice(0, 12)}...</td>
                  <td className="py-3 px-4 text-sm font-medium text-[#1A1A1A]">£{t.amount?.toFixed(2)}</td>
                  <td className="py-3 px-4 text-sm text-[#D4AF37]">£{t.commission?.toFixed(2)}</td>
                  <td className="py-3 px-4 text-sm text-green-600">£{((t.amount || 0) - (t.commission || 0)).toFixed(2)}</td>
                  <td className="py-3 px-4"><StatusBadge status={t.payment_status || 'unknown'} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
